/**
 * LacedUpChi — Product Recommendations
 *
 * Loads Shopify's server-rendered recommendation section. No product data,
 * pricing, recommendation logic, or tracking URLs are constructed in JS.
 */
(function () {
  'use strict';

  var controllers = new WeakMap();

  function initRecommendations(section) {
    if (!section || section.dataset.recommendationsInitialized === 'true') return;
    section.dataset.recommendationsInitialized = 'true';

    if (section.getAttribute('aria-busy') === 'false') return;

    var url = section.dataset.url;
    if (!url || typeof window.fetch !== 'function') {
      section.setAttribute('aria-busy', 'false');
      return;
    }

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    if (controller) controllers.set(section, controller);

    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendation request failed');
        return response.text();
      })
      .then(function (html) {
        if (!document.body.contains(section)) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-product-recommendations]');
        if (!incoming) throw new Error('Recommendation section missing');

        section.innerHTML = incoming.innerHTML;
        section.setAttribute('aria-busy', 'false');

        if (incoming.hasAttribute('hidden') || !incoming.innerHTML.trim()) {
          section.setAttribute('hidden', '');
        } else {
          section.removeAttribute('hidden');
        }

        controllers.delete(section);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (!document.body.contains(section)) return;
        section.setAttribute('aria-busy', 'false');
        section.setAttribute('hidden', '');
        controllers.delete(section);
      });
  }

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var section = event.target.querySelector('[data-product-recommendations]');
    var controller = section && controllers.get(section);
    if (controller) controller.abort();
  });

  window.theme = window.theme || {};
  if (window.theme.onSectionLoad) {
    window.theme.onSectionLoad('[data-product-recommendations]', initRecommendations);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      var sections = document.querySelectorAll('[data-product-recommendations]');
      Array.prototype.forEach.call(sections, initRecommendations);
    });
  }
})();
